
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectAllNitijisCustomerHistoriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainAdminId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subAdminId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kigyo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchingMail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nitijiStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDate"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nitijiEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AWSDate"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calendar"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientHistoriesInCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientHistoriesInChargeInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mainAdminId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainAdminId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subAdminId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAdminId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"kigyo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kigyo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"matchingMail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchingMail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nitijiStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nitijiStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nitijiEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nitijiEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"calendar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendar"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNitijis"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":515}};
    doc.loc.source = {"body":"query SelectAllNitijisCustomerHistoriesQuery (\n  $shopId: Int!,\n  $mainAdminId: Int,\n  $subAdminId: Int,\n  $kigyo: Int,\n  $matchingMail:Int,\n  $nitijiStart: AWSDate,\n  $nitijiEnd: AWSDate,\n  $calendar: String,\n){\n  clientHistoriesInCharge(clientHistoriesInChargeInput: {\n    shopId: $shopId,\n    mainAdminId: $mainAdminId,\n    subAdminId: $subAdminId,\n    kigyo: $kigyo,\n    matchingMail: $matchingMail,\n    nitijiStart: $nitijiStart,\n    nitijiEnd: $nitijiEnd,\n    calendar: $calendar,\n  }) {\n    allNitijis\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SelectAllNitijisCustomerHistoriesQuery"] = oneQuery(doc, "SelectAllNitijisCustomerHistoriesQuery");
        
